import { render, staticRenderFns } from "./courseTag.vue?vue&type=template&id=3f3982a4&"
import script from "./courseTag.vue?vue&type=script&lang=js&"
export * from "./courseTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports